import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ShirtStyle } from "../../models/ShirtStyle/shirtstyle.model";
import { IShirtStyleRepository } from "./IShirtStyleRepository";

@Injectable()
export class ShirtStyleRepository extends GenericRepository<ShirtStyle> implements IShirtStyleRepository {
    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/ShirtStyle', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this._http
            .get(this.url + 'api/ShirtStyle/SelectAll' + '/' + currentPage + '/' + recordsPerPage, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteRec(ShirtStyleCode: string) {
        return this._http.delete(this.url + 'api/ShirtStyle/DeleteRec/' + ShirtStyleCode, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveStyleNames(item: ShirtStyle) {
        return this._http.post(this.url + 'api/ShirtStyle/SaveStyleNames', item, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

}
